export const AUTH_LOADING = "AUTH_LOADING";
export const STOP_AUTH_LOADING = "STOP_AUTH_LOADING";
export const SUCCESS_LOGIN = "SUCCESS_LOGIN";
export const CHECKING_LOGIN = "CHECKING_LOGIN";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOG_OUT = "LOG_OUT";
export const RESET_AUTH = "RESET_AUTH";

export const LOADING_PRIVILEGE = "LOADING_PRIVILEGE";
export const SUCCESS_PRIVILEGE = "SUCCESS_PRIVILEGE";
export const ERROR_PRIVILEGE = "ERROR_PRIVILEGE";

export const LOADING_CHANGE_PASSWORD = "LOADING_CHANGE_PASSWORD";
export const SUCCESS_CHANGE_PASSWORD = "SUCCESS_CHANGE_PASSWORD";
export const ERROR_CHANGE_PASSWORD = "ERROR_CHANGE_PASSWORD";

export const LOADING_PAYMENT = "LOADING_PAYMENT";
export const SUCCESS_PAYMENT = "SUCCESS_PAYMENT";
export const ERROR_PAYMENT = "ERROR_PAYMENT";

// Intelligence solution
export const LOADING_BUSINESS_LANDING_DESCRIPTION =
  "LOADING_BUSINESS_LANDING_DESCRIPTION";
export const SUCCESS_BUSINESS_LANDING_DESCRIPTION =
  "SUCCESS_BUSINESS_LANDING_DESCRIPTION";
export const ERROR_BUSINESS_LANDING_DESCRIPTION =
  "ERROR_BUSINESS_LANDING_DESCRIPTION";

export const LOADING_BUSINESS_PAGE_CONTENT = "LOADING_BUSINESS_PAGE_CONTENT";
export const SUCCESS_BUSINESS_PAGE_CONTENT = "SUCCESS_BUSINESS_PAGE_CONTENT";
export const ERROR_BUSINESS_PAGE_CONTENT = "ERROR_BUSINESS_PAGE_CONTENT";

export const LOADING_SME_BUSINESS_LANDING_DESCRIPTION =
  "LOADING_SME_BUSINESS_LANDING_DESCRIPTION";
export const SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION =
  "SUCCESS_SME_BUSINESS_LANDING_DESCRIPTION";
export const ERROR_SME_BUSINESS_LANDING_DESCRIPTION =
  "LOADING_SME_BUSINESS_LANDING_DESCRIPTION";

export const LOADING_SME_BUSINESS_PAGE_CONTENT =
  "LOADING_SME_BUSINESS_PAGE_CONTENT";
export const SUCCESS_SME_BUSINESS_PAGE_CONTENT =
  "SUCCESS_SME_BUSINESS_PAGE_CONTENT";
export const ERROR_SME_BUSINESS_PAGE_CONTENT =
  "ERROR_SME_BUSINESS_PAGE_CONTENT";

// faults
export const LOADING_FAULT = "LOADING_FAULT";
export const SUCCESS_GET_FAULT_NATURE_OF_SERVICE =
  "SUCCESS_GET_FAULT_NATURE_OF_SERVICE";
export const SUCCESS_GET_FAULT_NATURE_OF_BILL =
  "SUCCESS_GET_FAULT_NATURE_OF_BILL";
export const SUCCESS_GET_FAULT_HISTORY_BY_DATE =
  "SUCCESS_GET_FAULT_HISTORY_BY_DATE";
export const SUCCESS_GET_FAULT_DETAILS_BY_REFNO =
  "SUCCESS_GET_FAULT_DETAILS_BY_REFNO";
export const SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES =
  "SUCCESS_GET_DATA_WITH_PRODUCT_ATTRIBUTES";
export const ERROR_FAULT = "ERROR_FAULT";
export const CLEAR_FAULT_ERROR = "CLEAR_FAULT_ERROR";
export const CLEAR_PAYMENT_ERROR = "CLEAR_PAYMENT_ERROR";

export const LOADING_FAULT_HISTORY = "LOADING_FAULT_HISTORY";
export const SUCCESS_FAULT_HISTORY = "SUCCESS_FAULT_HISTORY";
export const ERROR_FAULT_HISTORY = "ERROR_FAULT_HISTORY";
export const CLEAR_FAULT_HISTORY = "CLEAR_FAULT_HISTORY";

// external user
export const LOADING_EXTERNAL_USER = "LOADING_EXTERNAL_USER";
export const SUCCESS_GET_EXTERNAL_USERS = "SUCCESS_GET_EXTERNAL_USERS";
export const ERROR_EXTERNAL_USER = "ERROR_EXTERNAL_USER";

export const LOADING_GET_EXTERNAL_ROLE = "LOADING_GET_EXTERNAL_ROLE";
export const SUCCESS_GET_EXTERNAL_ROLE = "SUCCESS_GET_EXTERNAL_ROLE";
export const ERROR_GET_EXTERNAL_ROLE = "ERROR_GET_EXTERNAL_ROLE";

export const LOADING_CREATE_EXTERNAL_USER = "LOADING_CREATE_EXTERNAL_USER";
export const SUCCESS_CREATE_EXTERNAL_USER = "SUCCESS_CREATE_EXTERNAL_USER";
export const ERROR_CREATE_EXTERNAL_USER = "ERROR_CREATE_EXTERNAL_USER";

export const LOADING_DELETE_EXTERNAL_USER = "LOADING_DELETE_EXTERNAL_USER";
export const SUCCESS_DELETE_EXTERNAL_USER = "SUCCESS_DELETE_EXTERNAL_USER";
export const ERROR_DELETE_EXTERNAL_USER = "ERROR_DELETE_EXTERNAL_USER";

export const LOADING_GET_EXTERNAL_ROLE_BY_ID =
  "LOADING_GET_EXTERNAL_ROLE_BY_ID";
export const SUCCESS_GET_EXTERNAL_ROLE_BY_ID =
  "SUCCESS_GET_EXTERNAL_ROLE_BY_ID";
export const ERROR_GET_EXTERNAL_ROLE_BY_ID = "ERROR_GET_EXTERNAL_ROLE_BY_ID";

export const LOADING_GET_EXTERNAL_USER_BY_ID =
  "LOADING_GET_EXTERNAL_USER_BY_ID";
export const SUCCESS_GET_EXTERNAL_USER_BY_ID =
  "SUCCESS_GET_EXTERNAL_USER_BY_ID";
export const ERROR_GET_EXTERNAL_USER_BY_ID = "ERROR_GET_EXTERNAL_USER_BY_ID";

export const LOADING_ASSIGN_PRIVILEGES = "LOADING_ASSIGN_PRIVILEGES";
export const SUCCESS_ASSIGN_PRIVILEGES = "SUCCESS_ASSIGN_PRIVILEGES";
export const ERROR_ASSIGN_PRIVILEGES = "LOADING_ASSIGN_PRIVILEGES";

// dashboard
export const LOADING_CIRCUITS_BY_CUSTOMER_ID =
  "LOADING_CIRCUITS_BY_CUSTOMER_ID";
export const SUCCESS_CIRCUITS_BY_CUSTOMER_ID =
  "SUCCESS_CIRCUITS_BY_CUSTOMER_ID";
export const ERROR_CIRCUITS_BY_CUSTOMER_ID = "LOADING_CIRCUITS_BY_CUSTOMER_ID";

export const LOADING_CIRCUITS_BY_USER_ID = "LOADING_CIRCUITS_BY_USER_ID";
export const SUCCESS_CIRCUITS_BY_USER_ID = "SUCCESS_CIRCUITS_BY_USER_ID";
export const ERROR_CIRCUITS_BY_USER_ID = "LOADING_CIRCUITS_BY_USER_ID";

// usage page summary
export const SET_SELECTED_USAGE_PAGE_INDEX = "SET_SELECTED_USAGE_PAGE_INDEX";
export const SET_SELECTED_SELECTED_PACKAGE_TYPE =
  "SET_SELECTED_SELECTED_PACKAGE_TYPE";
export const SET_BROADBAND_ID = "SET_BROADBAND_ID";
export const SET_SELECTED_DAILY_USAGE_MONTH = "SET_SELECTED_DAILY_USAGE_MONTH";
export const CLEAR_USAGE_SUMMARY_PAGE_STATE = "CLEAR_USAGE_SUMMARY_PAGE_STATE";

export const LOADING_DATA_ADD_ONS = "LOADING_DATA_ADD_ONS";
export const SUCCESS_GET_DATA_ADD_ONS = "SUCCESS_GET_DATA_ADD_ONS";
export const ERROR_DATA_ADD_ONS = "ERROR_DATA_ADD_ONS";
export const SUCCESS_ADD_DATA_ADD_ON = "SUCCESS_ADD_DATA_ADD_ON";
